import { render, staticRenderFns } from "./FormExpansionHeader.vue?vue&type=template&id=f41815a0&"
import script from "./FormExpansionHeader.vue?vue&type=script&lang=js&"
export * from "./FormExpansionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VBadge,VExpansionPanelHeader})
